import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
    name: 'paginate',
    standalone: false
})
export class PaginatePipe implements PipeTransform {
  transform(items: Array<any>, currentPage: number, itemsPerPage: number): any {
    return _.take(_.drop(items, (currentPage - 1) * itemsPerPage), itemsPerPage);
  }
}
